import { render } from "./StoresToRelaunchBlock.vue?vue&type=template&id=22afc524"
import script from "./StoresToRelaunchBlock.vue?vue&type=script&lang=js"
export * from "./StoresToRelaunchBlock.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./StoresToRelaunchBlock.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_4739e77e%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Froadmap%2FStoresToRelaunchBlock.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__